import { render, staticRenderFns } from "./driver_page.vue?vue&type=template&id=4bf2fa57&scoped=true"
import script from "./driver_page.vue?vue&type=script&lang=js"
export * from "./driver_page.vue?vue&type=script&lang=js"
import style0 from "./driver_page.vue?vue&type=style&index=0&id=4bf2fa57&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf2fa57",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bf2fa57')) {
      api.createRecord('4bf2fa57', component.options)
    } else {
      api.reload('4bf2fa57', component.options)
    }
    module.hot.accept("./driver_page.vue?vue&type=template&id=4bf2fa57&scoped=true", function () {
      api.rerender('4bf2fa57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics_hongde/driver/driver_page.vue"
export default component.exports